module.exports = __webpack_public_path__ + "img/MIPL-png.86ee6a4.png";